import * as render from './render.pug'
import { you } from '~vueutil/member/wellknown.js'
import { ref } from 'vue'
import { NotificationListItemLayout } from '../layout/index.js'
import { shortenString } from '~core/dist/utils/string/shorten.js'
import { EventProvider } from '~vueutil/member/event/event-provider.js'

export const EventCreated = {
  ...render,
  emits: [],
  props: {
    notification: {
      type: Object
    }
  },
  components: {
    NotificationListItemLayout,
    EventProvider
  },
  directives: {},
  setup (props, { emit }) {
    const event = ref(null)
    return {
      you,
      event,
      shortenString
    }
  }
}
